module.exports = __webpack_public_path__ + "img/softinya-1.fa2ddbbe.png";